import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const styles = makeStyles(() => ({
  generalWrapper: {
    padding: "24px",
  },
  title: {
    font: "600 18px/24px Inter",
    color: getBrandCustom("primaryColor", "#38cfc4"),
  },
  subtitle: {
    font: "700 16px/18px Manrope",
    color: "#465869",
  },
}));

export default styles;
